import { Instance, SnapshotOut, types } from 'mobx-state-tree';

import { ChatbotResponse } from '../chatbot/Chatbot';

/**
 * # MissionDetail
 *
 * 미션 상세
 */
export const MissionDetail = types
  .model('MissionDetail')
  // --------------------------------------------------------------------------
  .props({
    conv_type: types.maybeNull(types.string),
    chatbot_response: types.maybeNull(ChatbotResponse),
  })
  // --------------------------------------------------------------------------
  // MUTATEs ONLY! - 모델 상태를 변경
  // REQUESTs는 스토어 모델에 작성하세요.
  // ex) yarn gen model missionDetail --store
  .actions((self) => ({
    /*
     * 여러 prop을 한번에 수정
     */
    setProps: (props: { [key: string]: any }) => {
      const newProps = { ...self, ...props } as IMissionDetail;
      (Object.keys(newProps) as TMissionDetailKeys[]).forEach((key) => {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        self[key] = newProps[key];
      });
    },
  }));

// --------------------------------------------------------------------------
type TMissionDetail = Instance<typeof MissionDetail>;
type TMissionDetailSnapshot = SnapshotOut<typeof MissionDetail>;

export interface IMissionDetail extends TMissionDetail {}
export type TMissionDetailKeys = keyof TMissionDetailSnapshot & string;
export interface IMissionDetailSnapshot extends TMissionDetailSnapshot {}
export const createMissionDetail = () => types.optional(MissionDetail, {} as TMissionDetail);
